import formatPods from './formatPods';
import themeEditor from './themeEditor';

export default () => {
  formatPods();
  themeEditor();
};